import { render, staticRenderFns } from "./c-full-empty.vue?vue&type=template&id=1f6fcc48&scoped=true"
import script from "./c-full-empty.vue?vue&type=script&lang=js"
export * from "./c-full-empty.vue?vue&type=script&lang=js"
import style0 from "./c-full-empty.vue?vue&type=style&index=0&id=1f6fcc48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fcc48",
  null
  
)

export default component.exports